export const MORPH_TRANSITION = {
  layout: {
    duration: 0.2,
    ease: [0.16, 1, 0.3, 1] as [number, number, number, number],
  },
  backdrop: {
    duration: 0.15,
    ease: 'linear' as const,
  },
  content: {
    itemDuration: 0.21,
    initialDelay: 0.07,
    stagger: 0.035,
  },
}
